import { createStore, combineReducers } from 'redux';
import langReducer from './reducers/langReducer';
import accessReducer from './reducers/accessReducer';
import buildingIdReducer from './reducers/buildingIdReducer';

const rootReducer = combineReducers({
    lang: langReducer,
    access: accessReducer,
    buildingId: buildingIdReducer
});

const store = createStore(rootReducer);

export type RootState = ReturnType<typeof rootReducer>;
export default store;
